import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorPayPal = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="#253B80"
      d="m9.157 21.69.372-2.358-.827-.019H4.754L7.498 1.917a.224.224 0 0 1 .222-.19h6.657c2.21 0 3.735.46 4.531 1.367.374.426.611.871.726 1.36.121.514.123 1.128.005 1.877l-.008.055v.48l.373.211c.285.144.541.34.756.576.32.364.526.827.613 1.376.09.564.06 1.235-.087 1.995-.17.875-.446 1.636-.818 2.26a4.646 4.646 0 0 1-1.295 1.418c-.494.351-1.08.617-1.744.787-.643.168-1.376.252-2.18.252h-.518c-.37 0-.73.134-1.013.373-.282.242-.47.576-.528.942l-.04.213-.655 4.155-.03.152c-.008.049-.021.073-.04.09a.11.11 0 0 1-.069.024H9.157Z"
    />
    <path
      fill="#179BD7"
      d="M20.358 6.441c-.02.127-.043.257-.069.39-.878 4.508-3.88 6.065-7.717 6.065H10.62c-.469 0-.864.34-.937.803l-1 6.342-.283 1.797a.5.5 0 0 0 .493.578h3.464c.41 0 .758-.298.823-.703l.034-.176.652-4.138.042-.227a.833.833 0 0 1 .823-.704h.518c3.357 0 5.984-1.363 6.752-5.306.32-1.647.154-3.023-.694-3.99-.27-.3-.59-.547-.948-.73Z"
    />
    <path
      fill="#222D65"
      d="M19.439 6.075a6.927 6.927 0 0 0-.854-.19c-.57-.087-1.145-.13-1.721-.125h-5.218c-.41 0-.76.298-.823.704l-1.11 7.03-.031.205a.948.948 0 0 1 .937-.803h1.953c3.836 0 6.84-1.558 7.717-6.065.026-.133.048-.263.068-.39a4.681 4.681 0 0 0-.918-.366Z"
    />
    <path
      fill="#253B80"
      d="M10.823 6.464a.83.83 0 0 1 .822-.703h5.218c.618 0 1.195.04 1.721.125.357.056.708.14 1.052.25.259.087.5.188.721.305.262-1.666-.002-2.8-.902-3.826C18.462 1.484 16.67 1 14.377 1H7.72a.951.951 0 0 0-.94.804L4.007 19.38a.572.572 0 0 0 .564.662h4.11l1.032-6.547 1.11-7.03Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColorPayPal)
export default ForwardRef
